<template>
    <div class="user-menu" v-if="user">
        <span class="initials">{{ user.initials }}</span>
        <a href class="user-menu-control" @click.prevent="toggleMenu">
            <span class="name">{{ displayName }}</span>
            <svg :class="{ 'open': dropDownVisible }" viewBox="0 0 24 24">
                <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
            </svg>
        </a>
        <ul class="user-menu-options" v-show="dropDownVisible">
            <li><a class="logout" href @click.prevent="logout">Log Out</a></li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'UserMenu',
        data: function() {
            return {
                authenticated: false,
                dropDownVisible: false
            }
        },
        computed: {
            ...mapGetters(['user']),
            displayName() {
                if (!this.user || !this.user.fullName) return '';
                // Remove domain part if it exists
                return this.user.fullName.split('@')[0];
            }
        },
        methods: {
            logout() {
                this.$emit('signOut')
            },
            toggleMenu() {
                this.dropDownVisible = !this.dropDownVisible
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    $initials-size: $spacing-unit * 1.5;

    .user-menu {
        position: relative;
        display: flex;
    }

    .initials {
        text-transform: uppercase;
        background-color: $blue-light;
        font-weight: 500;
        border-radius: 50%;
        color: $white;
        width: $initials-size;
        height: $initials-size;
        display: inline-block;
        text-align: center;
        line-height: $initials-size;
    }

    a {
        text-decoration: none;

        &:focus {
            outline: none;
        }
    }

    .user-menu-control {
        color: $black;
        display: flex;
        align-items: center;
        margin-left: math.div($spacing-unit, 2);

        @include bp(medium-down) {
            span {
                @include visually-hidden;
            }
        }
    }

    svg {
        width: $spacing-unit;
        height: $spacing-unit;

        &.open {
            transform: rotate(180deg);
        }
    }

    .user-menu-options {
        @include list-reset;

        position: absolute;
        right: 0;
        top: 100%;
        z-index: 1;
        white-space: nowrap;
        box-shadow: $grey-dark 0 2px 10px;
        border-radius: $border-radius;
        background-color: $white;
        overflow: hidden;

        li {
            border-bottom: solid $border-width-light $grey;

            &:last-child {
                border: none;
            }
        }

        a {
            display: block;
            height: $navigation-main-height;
            line-height: $navigation-main-height;
            padding: 0 $spacing-unit;

            &:hover, &:focus {
                background-color: $grey-light;
            }

            &:active {
                color: $blue;
            }
        }
    }

    .logout {
        color: $red;
        font-weight: 500;
    }
</style>
